import ContentBox from "../Components/ContentBox"
import Slider from "../Components/Slider"
import WorkSlide from "../Components/Workslide"
import { HomePageData } from "../Assets/data"

const Home=()=>{
    return(
        <>
        {/* <Layout> */}
           <Slider/>
           <ContentBox data={HomePageData}/>
           <WorkSlide/>
        {/* </Layout> */}
             
        </>
    )
}

export default Home